module.exports = __webpack_public_path__ + "static/media/Sequelize.9eb3918e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Skills/Sequelize.png
// module id = 119
// module chunks = 0